export default "__VITE_ASSET__fZ6GL4kp__"